module.exports = __webpack_public_path__ + "static/media/information.a37dc5b8.svg";